// need to delete this array and was added for Fruzqla by praneeth
export const Cost_Per_Quality_Visit_by_Channels_StaticDataFR = [   
    {
        'month': 'February 2024',
        'source_medium_group_data': {
            'Programmatic': 40.54,
            'EHR': 60.81,
            'Email': 0
        }
    },
    {
        'month': 'March 2024',
        'source_medium_group_data': {
            'Programmatic': 38.12,
            'EHR': 57.53,
            'Email': 0
        }
    },
    {
        'month': 'April 2024',
        'source_medium_group_data': {
            'Programmatic': 39.47,
            'EHR': 58.66,
            'Email': 0
        }
    },
    {
        'month': 'May 2024',
        'source_medium_group_data': {
            'Programmatic': 38.03,
            'EHR': 56.89,
            'Email': 0
        }
    },
    {
        'month': 'June 2024',
        'source_medium_group_data': {
            'Programmatic': 37.64,
            'EHR': 57.29,
            'Email': 0
        }
    },
    {
        'month': 'July 2024',
        'source_medium_group_data': {
            'Programmatic': 38.07,
            'EHR': 55.98,
            'Email': 0
        }
    },
    {
        'month': 'August 2024',
        'source_medium_group_data': {
            'Programmatic': 39.27,
            'EHR': 56.79,
            'Email': 37.22
        }
    },
    {
        'month': 'September 2024',
        'source_medium_group_data': {
            'Programmatic': 38.18,
            'EHR': 55.55,
            'Email': 34.71
        }
    }
];
export const Cost_Per_Quality_Visit_by_Channels_StaticDataRE = [   
    {
        'month': 'April 2024',
        'source_medium_group_data': {
            'Endemic Display': 53,
            'eNewsletter': 31,
            'EHR': 87,
            'Programmatic': 62,
            'Email': 0
        }
    },
    {
        'month': 'May 2024',
        'source_medium_group_data': {
            'Endemic Display': 52,
            'eNewsletter': 33,
            'EHR': 91,
            'Programmatic': 64,
            'Email': 0
        }
    },
    {
        'month': 'June 2024',
        'source_medium_group_data': {
            'Endemic Display': 56,
            'eNewsletter': 35,
            'EHR': 88,
            'Programmatic': 61,
            'Email': 0
        }
    },
    {
        'month': 'July 2024',
        'source_medium_group_data': {
            'Endemic Display': 51,
            'eNewsletter': 37,
            'EHR': 89,
            'Programmatic': 66,
            'Email': 37
        }
    },
    {
        'month': 'August 2024',
        'source_medium_group_data': {
            'Endemic Display': 47,
            'eNewsletter': 34,
            'EHR': 86,
            'Programmatic': 55,
            'Email': 35
        }
    },
    {
        'month': 'September 2024',
        'source_medium_group_data': {
            'Endemic Display': 49,
            'eNewsletter': 30,
            'EHR': 83,
            'Programmatic': 53,
            'Email': 38
        }
    }
];
export const Cost_Per_Quality_Visit_by_Channels_StaticDataREMM = [   
    {
        'month': 'September 2024',
        'source_medium_group_data': {
            'Endemic Display': 55,
            'eNewsletter': 37,
            'EHR': 88,
            'Programmatic': 65,
            'Email': 0
        }
    },
    {
        'month': 'October 2024',
        'source_medium_group_data': {
            'Endemic Display': 59,
            'eNewsletter': 42,
            'EHR': 86,
            'Programmatic': 61,
            'Email': 0
        }
    }
];
export const Cost_Per_Quality_Visit_by_Channels_StaticDataBA = [
    {
        'month': 'January 2024',
        'source_medium_group_data': {
            'Programmatic': 62.78,
            'EHR': 87.29
        }
    },
    {
        'month': 'February 2024',
        'source_medium_group_data': {
            'Programmatic': 69.56,
            'EHR': 84.68
        }
    },
    {
        'month': 'March 2024',
        'source_medium_group_data': {
            'Programmatic': 61.79,
            'EHR': 80.17
        }
    },
    {
        'month': 'April 2024',
        'source_medium_group_data': {
            'Programmatic': 71.21,
            'EHR': 83.95
        }
    },
    {
        'month': 'May 2024',
        'source_medium_group_data': {
            'Programmatic': 66.74,
            'EHR': 85.45
        }
    }
];

export const Cost_Per_Quality_Visit_by_Channels_StaticDataTP = [
    {
        'month': 'January 2024',
        'source_medium_group_data': {
            'Programmatic': 67.15,
            'EHR': 87.77
        }
    },
    {
        'month': 'February 2024',
        'source_medium_group_data': {
            'Programmatic': 66.28,
            'EHR': 81.56
        }
    },
    {
        'month': 'March 2024',
        'source_medium_group_data': {
            'Programmatic': 60.08,
            'EHR': 84.85
        }
    },
    {
        'month': 'April 2024',
        'source_medium_group_data': {
            'Programmatic': 62.77,
            'EHR': 80.21
        }
    },
    {
        'month': 'May 2024',
        'source_medium_group_data': {
            'Programmatic': 63.11,
            'EHR': 84.22
        }
    }
];

export const Cost_Per_Quality_Visit_by_Channels_StaticDataXE = [
    {
        'month': 'January 2024',
        'source_medium_group_data': {
            'Banner Ad': 50.12,
            'Programmatic': 62.31,
            'Paid Search': 0
        }
    },
    {
        'month': 'February 2024',
        'source_medium_group_data': {
            'Banner Ad': 54.71,
            'Programmatic': 61.19,
            'Paid Search': 189.00
        }
    },
    {
        'month': 'March 2024',
        'source_medium_group_data': {
            'Banner Ad': 0,
            'Programmatic': 64.87,
            'Paid Search': 201.00
        }
        
    },
    {
        'month': 'April 2024',
        'source_medium_group_data': {
            'Banner Ad': 0,
            'Programmatic': 63.47,
            'Paid Search': 197.00
        }
    }
];

export const Cost_Per_Quality_Visit_by_Channels_StaticDataZP = [   
    {
        'month': 'July 2024',
        'source_medium_group_data': {
            'Endemic Display': 0,
            'eNewsletter': 0,
            'EHR': 0,
            'Programmatic': 69,
            'Email': 0
        }
    },
    {
        'month': 'August 2024',
        'source_medium_group_data': {
            'Endemic Display': 0,
            'eNewsletter': 0,
            'EHR': 78,
            'Programmatic': 57,
            'Email': 0
        }
    },
    {
        'month': 'September 2024',
        'source_medium_group_data': {
            'Endemic Display': 52,
            'eNewsletter': 33,
            'EHR': 69,
            'Programmatic': 60,
            'Email': 0
        }
    },
    {
        'month': 'October 2024',
        'source_medium_group_data': {
            'Endemic Display': 45,
            'eNewsletter': 26,
            'EHR': 66,
            'Programmatic': 66,
            'Email': 0
        }
    }
];
export const Cost_Per_Quality_Visit_by_Channels_StaticDataRPD = [   
    {
        'month': 'January 2025',
        'source_medium_group_data': {
            'Paid Media': 90.55,
            'Paid Search': 82.47
        }
    },
    {
        'month': 'February 2025',
        'source_medium_group_data': {
            'Paid Media': 37.62,
            'Paid Search': 54.85
        }
    },
    {
        'month': 'March 2025',
        'source_medium_group_data': {
            'Paid Media': 51.88,
            'Paid Search': 34.65
        }
    }
    
];

export const ctr_broken_down_by_creative_type_data = [   
    {
        'month': 'February 2025',
        'source_medium_group_data': {
            'Challenges in Adv.- NPM03 ': 0.0244,
            'Challenges in Adv.- NPM04 ': 0.0178,
            'Collaboration_NPM03': 0.0361,
            'Collaboration_NPM04': 0.0260,
            'Combination of IO_NPM03': 0.0265,
            'Combination of IO_NPM04': 0.0210,
            'Evolution of IO_NPM04': 0.0250,
            'Evolution of OI_NPM03': 0.0285,
            'NPM-0010-Static ': 0.0163
        }
    },
    {
        'month': 'March 2025',
        'source_medium_group_data': {
            'Challenges in Adv.- NPM03 ': 0.0194,
            'Challenges in Adv.- NPM04 ': 0.0127,
            'Collaboration_NPM03': 0.0213,
            'Collaboration_NPM04': 0.0164,
            'Combination of IO_NPM03': 0.0144,
            'Combination of IO_NPM04': 0.0154,
            'Evolution of IO_NPM04': 0.0161,
            'Evolution of OI_NPM03': 0.0155,
            'NPM-0010-Static ': 0.0157
        }
    }
];

export const qvr_by_hva_chart_data = [   
    {
        'month': 'February 2025',
        'source_medium_group_data': {
            'Contact us form on the full website': 0,
            'Zip code search on the IGNYTE-3 page': 398,
            '"Print" button on clinical trial overview on the IGNYTE-3 page': 415,
            'Clicking to email clinical trial team on the IGNYTE-3 page': 106,
            'Downloaded any publications on the Medical Affairs page': 51
        }
    },
    {
        'month': 'March 2025',
        'source_medium_group_data': {
            'Contact us form on the full website': 0,
            'Zip code search on the IGNYTE-3 page': 434,
            '"Print" button on clinical trial overview on the IGNYTE-3 page': 399,
            'Clicking to email clinical trial team on the IGNYTE-3 page': 84,
            'Downloaded any publications on the Medical Affairs page': 28
        }
    }
];

export const qvr_by_hva_chart_data_66 =[   
    {
        'month': 'February 2025',
        'source_medium_group_data': {
            '1 click or more on toggles or navigation button': 387,
            'Completion of the contact us form': 349,
            '1 or more PDF downloaded': 338
        }
    },
    {
        'month': 'March 2025',
        'source_medium_group_data': {
            '1 click or more on toggles or navigation button': 1402,
            'Completion of the contact us form': 1349,
            '1 or more PDF downloaded': 1314
        }
    }
];

